import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "phone-number-input mb-3" }
const _hoisted_2 = {
  key: 0,
  for: "name",
  class: "form-label"
}
const _hoisted_3 = ["placeholder", "disabled", "readonly"]
const _hoisted_4 = {
  key: 1,
  class: "text-danger"
}

import { ref, watch } from 'vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'PhoneNumber',
  props: {
  modelValue: {
    type: String,
    default: '',
  },
  label: String,
  placeholder: {
    type: String,
    default: 'Enter phone number',
  },
  disabled: Boolean,
  readonly: Boolean,
  v: {
    type: Object,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;

const phoneNumber = ref(props.modelValue);
const errorMessage = ref('');
const emits = __emit;


const handleInput = () => {
  // Remove non-numeric characters from phone number
  phoneNumber.value = phoneNumber.value.replace(/\D/g, '');

  // Emit the sanitized phone number
  emits('update:modelValue', phoneNumber.value ?? '');
 
}; 

watch(() => props.modelValue, (newValue) => {
  phoneNumber.value = newValue; 
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("b", _hoisted_2, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((phoneNumber).value = $event)),
      type: "tel",
      placeholder: __props.label,
      disabled: __props.disabled,
      readonly: __props.readonly,
      onInput: handleInput,
      class: "form-control"
    }, null, 40, _hoisted_3), [
      [_vModelText, phoneNumber.value]
    ]),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.v?.$errors, (error) => {
      return (_openBlock(), _createElementBlock("span", {
        class: "text-danger",
        key: error.$uid
      }, [
        _createTextVNode(" - " + _toDisplayString(error.$message) + " ", 1),
        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1))
      ]))
    }), 128))
  ]))
}
}

})